import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";


// data
import { RejectedLoanList} from "./rejectedLoanList-api"
//auth
import auth from "../../../auth/auth-helper";

const columns = [
  {
    name: "account_no",
    label: "Accunt No",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "amount",
    label: "Amount",
  },
  {
    name: "rejected_by",
    label: "Rejected by",
  },
  {
    name: "date",
    label: "Date",
  },
  {
    name: "branch_name",
    label: "Branch Name",
  },
  {
    name: "installment",
    label: "Installement",
  },
  {
    name: "installment_type",
    label: "Installement Type",
  },
  {
    name: "loan_status",
    label: "Status",
  },
  {
    name: "loan_type",
    label: "Loan Type",
  },
  {
    name: "requested_by",
    label: "Requested By",
  },
  {
    name: "time_period",
    label: "Time Peroid",
  },
  {
    name: "reason",
    label: "Reason",
  },
];


export default function RejectedLoans() {
  const [onlineloans, setOnlineloans] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    RejectedLoanList(signal,credentials).then((res) => {
      if (res.status === 200) {
        console.log('token here .....................'+ credentials);
        // console.log(res.status);
        console.log(res);
        //console.log(res.statusCode);
        setOnlineloans(res.response);
      } else {
        
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Rejected Loans" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Rejected-Loan List"
            data={onlineloans}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={onlineloans} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}